<template>
  <span class="banner-coupon-preload">
    <content-loader
      :height="340"
      :width="290"
      :speed="2"
      primaryColor="#f3f3f3"
      secondaryColor="#ecebeb"
    >
      <rect x="59.5" y="23.2" rx="0" ry="0" width="168.75" height="34.2" />
      <rect x="63.5" y="90.2" rx="0" ry="0" width="164.25" height="127.22" />
      <rect x="33.5" y="249.2" rx="0" ry="0" width="234" height="35.91" />
    </content-loader>
  </span>
</template>

<script>
export default {
  name: "CardPreload"
};
</script>

<style lang="scss"></style>
